export class EFormSurveyFieldCriticalValue {
    ID: number;
    SurveyFieldID: number;
    Value: string;
    AddedOn: Date;
    Addedby: number;
    LastUpOn: Date;
    LastUpBy: number;
   }